var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCerrarCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1402_10468)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 25,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 25,
    r: 15,
    stroke: "#1A3D82",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5607 25.4848L31.358 21.6875C31.4436 21.6233 31.5144 21.5415 31.5656 21.4476C31.6168 21.3536 31.6472 21.2498 31.6548 21.1431C31.6624 21.0364 31.647 20.9293 31.6096 20.8291C31.5721 20.7289 31.5136 20.6378 31.438 20.5622C31.3624 20.4866 31.2713 20.428 31.1711 20.3906C31.0709 20.3532 30.9638 20.3378 30.8571 20.3454C30.7504 20.353 30.6466 20.3834 30.5526 20.4346C30.4587 20.4858 30.3769 20.5566 30.3127 20.6422L26.5154 24.4395L22.718 20.6422C22.6538 20.5566 22.572 20.4858 22.4781 20.4346C22.3842 20.3834 22.2803 20.353 22.1736 20.3454C22.0669 20.3378 21.9598 20.3532 21.8596 20.3906C21.7594 20.428 21.6684 20.4866 21.5927 20.5622C21.5171 20.6378 21.4586 20.7289 21.4212 20.8291C21.3838 20.9293 21.3683 21.0364 21.3759 21.1431C21.3835 21.2498 21.4139 21.3536 21.4651 21.4476C21.5163 21.5415 21.5871 21.6233 21.6727 21.6875L25.47 25.4848L21.6727 29.2822C21.6024 29.3498 21.5464 29.431 21.5082 29.5208C21.47 29.6106 21.4503 29.7072 21.4503 29.8048C21.4503 29.9024 21.47 29.999 21.5082 30.0889C21.5464 30.1787 21.6024 30.2598 21.6727 30.3275C21.7431 30.3965 21.8265 30.4509 21.918 30.4875C22.0096 30.5241 22.1074 30.5423 22.206 30.5408C22.3982 30.5404 22.5824 30.4636 22.718 30.3275L26.5154 26.5302L30.3127 30.3275C30.4484 30.4636 30.6325 30.5404 30.8247 30.5408C30.9233 30.5423 31.0212 30.5241 31.1127 30.4875C31.2042 30.4509 31.2876 30.3965 31.358 30.3275C31.4284 30.2598 31.4843 30.1787 31.5225 30.0889C31.5607 29.999 31.5804 29.9024 31.5804 29.8048C31.5804 29.7072 31.5607 29.6106 31.5225 29.5208C31.4843 29.431 31.4284 29.3498 31.358 29.2822L27.5607 25.4848Z",
    fill: "#1A3D82"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1402_10468",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1402_10468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1402_10468",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarCircle);
export default __webpack_public_path__ + "static/media/cerrar-circle.b96fae588fdd05787ac71cd998c61bbd.svg";
export { ForwardRef as ReactComponent };